import React, {useState, useEffect, useMemo} from "react";

import CodeMirror from "@uiw/react-codemirror";
import { dracula } from "@uiw/codemirror-theme-dracula";
import { javascript } from "@codemirror/lang-javascript";
import { EditorView } from "@codemirror/view";
import { libraries, defaultCode } from "../lib/utils";
import { ethers } from "ethers";
import Header from "../components/Header";
import CreateCommands from "../components/base/CreateCommands";
import Modal from 'react-modal';
import TextInput from "../components/base/TextInput";
import Select from "../components/base/Select";
import "../styles/Create.css"
import { minify } from "terser";

const customStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    boxShadow: 'rgba(100, 100, 111, 0.2) 0px 7px 29px 0px',
    borderRadius: '30px',
    backdropFilter: 'blur(50px)',
    color : 'white',
    background: 'rgb(0, 0, 0)',
  },
};

const Create = () => {
  const [collection, setCollection] = useState();
  const [code, setCode] = useState(defaultCode);
  const [tokenId, setTokenId] = useState("0");
  const [minter, setMinter] = useState("Owner");
  const [library, setLibrary] = useState("p5");
  const [autoRefresh, setAutoRefresh] = useState(true);
  const [wordWrap, setWordWrap] = useState(true);
  const [hash, setHash] = useState(ethers.utils.hexlify(ethers.utils.randomBytes(32)));
  const [modalIsOpen, setIsOpen] = React.useState(false);
  const [script, setScript] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  //collection information
  const [formData, setFormData] = useState({
    contractType: "Learn",
    name: "",
    symbol: "",
    description: "",
    artist: "",
    defaultImage: "",
    maxSupply: 0,
    price: 0,
    _library: "p5",
    code: "",
  });

  useEffect(()=>{
    generateOutput(hash)
  }, [code])
  const libraryScript = useMemo(() => `<script src="${libraries[library]}"></script>`, [library]);

  const generateOutput = (_hash) => {
    if (document) {
      const tokenData = `window.tokenData={"tokenId": "${tokenId}", "hash": "${_hash}", "hashes": ["${_hash}"], "minter": "${minter}"};`;
      const wrappedCode = `<html><head>${libraryScript}</head><body style="margin: 0px;display: flex;justify-content: center;"><script>${tokenData}${code}</script></body></html>`;
      // @ts-ignore
      document.getElementById("liveArtBlock").srcdoc = wrappedCode;
    }
  };

  const handleRun = (event) => {
    event.preventDefault();
    generateOutput(hash);
  };

  const updateHash = (_hash) => {
    setHash(_hash);
    if (autoRefresh) {
      generateOutput(_hash);
    }
  };

  const openModal = async (event) => {
    event.preventDefault();
    try {
      setIsLoading(true);
      setError(null);
      const result = await minify(code);
      setFormData({...formData, 'code': result.code});
      setIsOpen(true);
    } catch (err) {
      console.error("Error minifying code:", err);
      setError("Failed to process code. Please try again.");
    } finally {
      setIsLoading(false);
    }
  }

  const closeModal = () => {
    setIsOpen(false)
  }

  const handleCreate = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError(null);
    
    try {
      // TODO: Implement actual collection creation logic
      // This should call your smart contract or API
      console.log("Creating collection with data:", formData);
      
      // Example validation
      if (!formData.name || !formData.symbol) {
        throw new Error("Name and Symbol are required");
      }
      
      // Add your creation logic here
      // await createCollection(formData);
      
      alert("Collection created successfully!");
      setIsOpen(false);
      // Reset form or navigate away
    } catch (err) {
      console.error("Error creating collection:", err);
      setError(err.message || "Failed to create collection");
    } finally {
      setIsLoading(false);
    }
  }

  const handleDescriptionChange = (e) => {
    setFormData({...formData, 'description': e.target.value});
  }

  const handleCodeChange = (e) => {
    setFormData({...formData, 'code': e.target.value});
  }

  return (
    <>
      <Header />
      {error && (
        <div style={{color: 'red', padding: '10px', textAlign: 'center'}}>{error}</div>
      )}
      <CreateCommands 
        collection = {collection}
        hash = {hash}
        updateHash = {updateHash}
        minter = {minter}
        setMinter = {setMinter}
        handleRun = {handleRun}
        autoRefresh = {autoRefresh}
        setAutoRefresh = {setAutoRefresh}
        wordWrap = {wordWrap}
        setWordWrap = {setWordWrap}
        library = {library}
        setLibrary = {setLibrary}
        handleCreate = {openModal}
      />
      <div className="newNFT_container">
        <div style={{width : '60%', textAlign : "left", fontSize : "18px"}}>
          <CodeMirror
            value={code}
            height="800px"
            theme={dracula}
            extensions={[...(wordWrap ? [EditorView.lineWrapping] : []), javascript()]}
            onChange={(code) => setCode(code)}
          />
        </div>
        <div style={{width : '40%'}}>
          <iframe
            title="ArtBlock"
            scrolling="no"
            style={{ overflow: "hidden", width : '100%', height : '100%'}}
            className="overflow-hidden w-full h-full col-span-3"
            id="liveArtBlock"
          />
        </div>
      </div>
      <Modal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        style={customStyles}
        contentLabel="Create Collection Modal"
      >
        <div className="modalMain">
          <h2>Create New Collection</h2>
          {error && <div style={{color: 'red', padding: '10px'}}>{error}</div>}
            <div className="row">
              <div className="col-4">
                <label htmlFor="collection-name">Name</label>
                <TextInput width={100} height={50} placeholder={"Collection Name"} type={"text"} changefilter={(value)=>{setFormData({...formData, 'name' : value})}}/>
              </div>
              <div className="col-4">
                <label htmlFor="collection-symbol">Symbol</label>
                <TextInput width={100} height={50} placeholder={"Collection Symbol"} type={"text"} changefilter={(value)=>{setFormData({...formData, 'symbol' : value})}}/>
              </div>
            </div>
            <div className="row">
              <div className="col-4">
                <label htmlFor="collection-artist">Artist</label>
                <TextInput width={100} height={50} placeholder={"Collection Artist"} type={"text"} changefilter={(value)=>(setFormData({...formData, 'artist' : value}))}/>
              </div>
              <div className="col-4">
                <label htmlFor="collection-image">Default collection image (URL / IPFS)</label>
                <TextInput width={100} height={50} placeholder={"Collection Default Image"} type={"text"} changefilter={(value)=>(setFormData({...formData, 'defaultImage' : value}))}/>
              </div>
            </div>
            <div className="row">
              <div className="col-12">
                <label htmlFor="collection-description">Description</label>
                <textarea 
                  id="collection-description"
                  className="collectionDescription" 
                  placeholder={"Collection description"} 
                  value={formData.description}
                  onChange={handleDescriptionChange}
                  aria-label="Collection description"
                />
              </div>
            </div>
            <div className="row">
              <div className="col-4">
                <label htmlFor="collection-max-supply">Max Supply</label>
                <TextInput width={100} height={50} value = {formData.maxSupply} placeholder={"0"} type={"text"} changefilter={(value)=>(setFormData({...formData, 'maxSupply' : value}))}/>
              </div>
              <div className="col-4">
                <label htmlFor="collection-price">Price</label>
                <TextInput width={100} height={50} placeholder={"Collection Price"} type={"text"} changefilter={(value)=>(setFormData({...formData, 'price' : value}))}/>
              </div>
            </div>
            <div className="row">
              <div className="col-4">
                <label htmlFor="collectionType">Type</label>
                <Select
                    initValue = {formData.contractType}
                    items = {['Learn', 'Certificate']}
                    onChange = {(value)=>{setFormData({...formData, 'contractType' : value})}}
                />
              </div>
              <div className="col-4">
                <label htmlFor="collectionType">Library</label>
                <Select
                    initValue = {formData._library}
                    items = {["P5", "Three"]}
                    onChange = {(value)=>{setFormData({...formData, '_library' : value})}}
                />
              </div>
            </div>
            <div className="row">
              <div className="col-12">
                <label htmlFor="collection-code">Code</label>
                <textarea 
                  id="collection-code"
                  className="collectionDescription" 
                  placeholder={"Collection Code"} 
                  value={formData.code}
                  onChange={handleCodeChange}
                  aria-label="Collection code"
                />
              </div>
            </div>
            <div className="row" style={{padding : '50px', justifyContent : 'center'}}>
              <div style={{width : '80%', display : "flex", justifyContent : 'space-around'}}>
                <button 
                  id="create" 
                  onClick={closeModal} 
                  disabled={isLoading}
                  aria-label="Close modal"
                >
                  Close
                </button>
                <button 
                  id="explore" 
                  onClick={handleCreate} 
                  disabled={isLoading}
                  aria-label="Create collection"
                >
                  {isLoading ? "Creating..." : "Create"}
                </button>
              </div>
            </div>
        </div>
      </Modal>
    </>
  );
};

export default Create;
